"use client";

import Image from "next/image";
import heroImgAsset from "@/assets/bachelor-hospitality/hero-hotel.jpg";
import logoRoseateAsset from "@/assets/bachelor-hospitality/JW_Marriott_Logo.png";
import logoJwMarriottAsset from "@/assets/bachelor-hospitality/Roseate_Logo.png";
import logoLeelaAsset from "@/assets/bachelor-hospitality/leela-logo.png";
import AdmissionForm from "./Admissionform";

const HeroSection = () => {
    return (
        <section className="relative min-h-screen overflow-hidden bg-black" id="apply">
            <div className="absolute inset-0">
                <Image
                    src={heroImgAsset}
                    alt="Hotel Background"
                    fill
                    priority
                    className="object-cover"
                />
                <div className="absolute inset-0 bg-black/65 backdrop-blur-[2px]" />
            </div>

            <div className="relative z-10 max-w-(--max-page-width) mx-auto px-(--container-padding) w-full py-16 ">
                <div className="flex flex-col lg:flex-row gap-10 items-startl">
                    <div className="w-full lg:w-7/12 text-white">
                        <div className="mb-4 inline-flex items-center rounded-full border border-yellow-500/40 bg-black/20 px-6 py-2 backdrop-blur-md">
                            <span className="mr-2 h-3 w-3 rounded-full text-[#FFAA1A]"></span>

                            <span className="text-xs font-semibold tracking-wider text-[#FFAA1A] uppercase">
                                ADMISSIONS OPEN — JULY 2026
                            </span>
                        </div>
                        <h1 className="max-w-xl text-xl font-extrabold leading-tight md:text-5xl">
                            Earn Your Degree Working with {" "}
                            <span className="text-[#FFAA1A]">Real Hotels</span>
                        </h1>

                        <p className="mt-4 text-lg font-medium tracking-widest text-[#FFAA1A]/80 md:text-lg">
                            Learn · Earn · Lead
                        </p>

                        <div className="mt-5 max-w-xl rounded-3xl border border-white/10 bg-white/10 p-6 backdrop-blur-xl md:p-8">
                            <p className="text-lg md:text-xl font-medium leading-snug">
                                India&apos;s First{" "}
                                <span className="rounded-lg bg-[#FFAA1A] px-3 py-1 text-black">
                                    Industry-Sponsored
                                </span>{" "}
                                B.Sc. in Hospitality & Hotel Management Programme
                                {/* <span className="text-[#FFAA1A]/80">
                                    Real Luxury Hotels.
                                </span> */}
                            </p>
                        </div>

                        <div className="mt-12 w-full md:max-w-3xl">
                            <p className="mb-6 text-sm font-semibold uppercase tracking-[4px] text-[#FFAA1A]/80">
                                Train with Leading Hotel Brands
                            </p>

                            <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
                                <div className="flex flex-col justify-center items-center rounded-3xl border
                             border-white/10 bg-white/10 px-1 py-4 text-center backdrop-blur-xl transition hover:bg-white/15">
                                    <Image
                                        src={logoRoseateAsset}
                                        alt={'logo Roseate Asset'}
                                        width={110}
                                        height={60}
                                        className="w-auto h-12.5 md:h-15 object-contain"
                                    />
                                    {/* <h3 className="text-md font-light tracking-[6px] mt-3">
                                        JW MARRIOTT 
                                    </h3> */}

                                    {/* <p className="mt-1 text-[10px] uppercase tracking-[3px] text-gray-300">
                                        Hotels & Resorts
                                    </p> */}

                                    <p className="mt-2 text-sm text-[#FFAA1A]">
                                        Kolkata
                                    </p>
                                </div>

                                <div className="flex flex-col justify-center items-center rounded-3xl border
                             border-white/10 bg-white/10 px-1 py-4 text-center backdrop-blur-xl transition hover:bg-white/15">
                                    <Image
                                        src={logoJwMarriottAsset}
                                        alt={'JwMarriott '}
                                        width={110}
                                        height={60}
                                        className="w-auto h-12.5 md:h-15 object-contain"
                                    />
                                    {/* <h3 className="text-md font-light tracking-wide mt-3">
                                        ROSEATE
                                    </h3> */}

                                    <p className="mt-2 text-sm text-[#FFAA1A]">
                                        Delhi NCR
                                    </p>
                                </div>

                                <div className="flex flex-col justify-center items-center rounded-3xl border border-white/10 bg-white/10 px-1 py-4 text-center backdrop-blur-xl transition hover:bg-white/15">
                                    <Image
                                        src={logoLeelaAsset}
                                        alt={'Leela'}
                                        width={110}
                                        height={60}
                                        className="w-auto h-12.5 md:h-15 object-contain"
                                    />

                                    {/* <h3 className="text-md font-light tracking-wide mt-3">
                                        THE LEELA
                                    </h3> */}

                                    {/* <p className="mt-1 text-[10px] uppercase tracking-[3px] text-gray-300">
                                        Palaces Hotels Resorts
                                    </p> */}

                                    <p className="mt-2 text-sm text-[#FFAA1A]">
                                        Delhi
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="w-full lg:w-6/12 flex justify-center lg:justify-end">
                        <div className="w-full max-w-lg">
                            <AdmissionForm />
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default HeroSection